import type {IFetchContext} from "@pg-mono/data-fetcher";

import type {IRPStore} from "../../app/rp_reducer";
import type {IRPRequestMeta} from "../../app/rp_request_meta";
import {getOfferDisplayStatus} from "../../offer/utils/get_offer_display_status";
import {PropertyDisplayType} from "../../property/types/PropertyDisplayType";
import {isPropertyForSale as isPropertyDetailForSale} from "../../property/utils/is_property_for_sale";
import type {IAppDispatch} from "../../store/store";
import {getRecommendedProperties} from "../api/get_recommended_properties";
import {useRecommendedPropertiesPayload} from "../hooks/use_recommended_properties_payload";

export const fetchRecommendedPropertiesAtRoute = (_ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: IAppDispatch, getState: () => IRPStore) => {
    const property = getState().property.property;

    if (property) {
        /*
         * Same logic as in the PropertyDetailView
         * TODO: extract this logic to a common helper function
         */
        const isForSale = isPropertyDetailForSale(property);
        const isForSaleOverLimit = getOfferDisplayStatus(property.offer) === "limited";
        const isLimited = getOfferDisplayStatus(property.offer) === "limited";
        const isClassicView = (isForSale || isForSaleOverLimit) && !isLimited;
        const isPropertyForSale = property.for_sale;
        const isPropertyPublished = property.configuration.display_type === PropertyDisplayType.PUBLISHED;

        if (isClassicView && isPropertyForSale && isPropertyPublished) {
            const maxPrice = getState().user.preferences?.data?.filters?.price_1 || property.price?.toString();
            const payload = useRecommendedPropertiesPayload({property, filters: {maxPrice}});

            if (payload) {
                await dispatch(getRecommendedProperties.endpoints.getRecommendedProperties.initiate(payload));
            }
        }
    }

    return true;
};
import type {IFetchContext} from "@pg-mono/data-fetcher";

import type {IRPStore} from "../../app/rp_reducer";
import type {IRPRequestMeta} from "../../app/rp_request_meta";
import {getOfferDisplayStatus} from "../../offer/utils/get_offer_display_status";
import {PropertyDisplayType} from "../../property/types/PropertyDisplayType";
import {isPropertyForSale as isPropertyDetailForSale} from "../../property/utils/is_property_for_sale";
import type {IAppDispatch} from "../../store/store";
import {getRecommendedProperties} from "../api/get_recommended_properties";
import {useRecommendedPropertiesPayload} from "../hooks/use_recommended_properties_payload";

export const fetchRecommendedPropertiesAtRoute = (_ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: IAppDispatch, getState: () => IRPStore) => {
    const property = getState().property.property;

    if (property) {
        /*
         * Same logic as in the PropertyDetailView
         * TODO: extract this logic to a common helper function
         */
        const isForSale = isPropertyDetailForSale(property);
        const isForSaleOverLimit = getOfferDisplayStatus(property.offer) === "limited";
        const isLimited = getOfferDisplayStatus(property.offer) === "limited";
        const isClassicView = (isForSale || isForSaleOverLimit) && !isLimited;
        const isPropertyForSale = property.for_sale;
        const isPropertyPublished = property.configuration.display_type === PropertyDisplayType.PUBLISHED;

        if (isClassicView && isPropertyForSale && isPropertyPublished) {
            const maxPrice = getState().user.preferences?.data?.filters?.price_1 || property.price?.toString();
            const payload = useRecommendedPropertiesPayload({property, filters: {maxPrice}});

            if (payload) {
                await dispatch(getRecommendedProperties.endpoints.getRecommendedProperties.initiate(payload));
            }
        }
    }

    return true;
};
